/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";
import { useLenis } from "./SmoothScroll";

const Attorney = () => {
  const lenisRef = useLenis();
  useEffect(() => {
    lenisRef?.current?.scrollTo(0); // top of the page
  }, []);
  return (
    <>
      <title>
        Clinician Resources | Citrus Diagnostic Center Crystal River
      </title>
      <meta
        name="description"
        content="Citrus Diagnostic Center collaborates with Clearpath to provide attorneys with secure, quick access to medical imaging records for efficient case evaluation."
      />
      <div className="flex justify-center items-center ">
        <div className="w-full sm:w-4/5 flex flex-col items-center pb-8 lg:pb-16">
          <h1
            className="text-[#d78558] font-robout lg:text-7xl md:text-4xl text-3xl pt-20 capitalize text-center leading-tight sm:leading-snug font-black"
          >
            Attorneys & Clearpath
          </h1>

          <div className="md:text-left md:w-full text-center flex flex-col justify-center items-center lg:pt-20 pt-12 mx-4">
            <h2 className="lg:text-4xl text-3xl text-[#d78558] font-bold md:px-8 px-4 w-full sm:w-4/5 md:w-full pb-8">
              Fast & Secure Access to Medical Records
            </h2>
            <p className="xl:text-[1.33rem] text-base sm:text-lg text-white lg:ps-0 md:px-8 px-4 pb-8 w-full sm:w-4/5 md:w-full font-robout break-words">
              We know how important it is for you to get the medical records and
              images on time and all maintained in one place. Our partnership
              with Clearpath is a step towards easing our clients' privacy
              concerns. Be it attorneys, legal teams, or insurance carriers, all
              of them can securely access imaging results, radiology reports,
              and billing statements without needing to wait for physical
              reports or discs.
            </p>

            <h2 className="lg:text-4xl text-3xl text-[#d78558] font-bold md:px-8 px-4 w-full sm:w-4/5 md:w-full pb-8">
              Why We Use Clearpath?
            </h2>
            <p className="xl:text-[1.33rem] text-base sm:text-lg text-white lg:ps-0 md:px-8 px-4 pb-8 w-full sm:w-4/5 md:w-full font-robout break-words">
              We at Citrus Diagnostic Center focus more on our patients' safety
              and security from their first visit to providing them with endless
              support. Our collaboration with Clearpath is exactly to serve the
              purpose because of the following reasons-
            </p>

            <ul className="xl:text-[1.33rem] list-disc text-base sm:text-lg flex flex-col gap-3 w-full sm:w-4/5 md:w-full text-white px-6 sm:px-8 pb-8 mx-4 sm:mx-8 text-left font-robout">
              <li>
                100% digital access to imaging and records with no delays.
              </li>
              <li>
                24/7 HIPAA-compliant portal accessible from any device,
                anywhere.
              </li>
              <li>Reliable, secure transmission and viewing</li>
              <li>Secure and accurate access to the medical documents.</li>
              <li>Hassle-free account setup and online payment.</li>
              <li>
                Downloading images, reports, and necessary affidavits easily.
              </li>
            </ul>

            <h2 className="lg:text-4xl text-3xl text-[#d78558] font-bold md:px-8 px-4 w-full sm:w-4/5 md:w-full pb-8">
              Requesting Medical Records
            </h2>
            <p className="xl:text-[1.33rem] text-base sm:text-lg text-white lg:ps-0 md:px-8 w-full sm:w-4/5 md:w-full px-4 pb-8 font-bold font-robout">
              By following the simple steps, anyone can access the medical
              records quickly-
            </p>

            <ul className="xl:text-[1.33rem] list-disc text-base sm:text-lg flex flex-col gap-3 w-full sm:w-4/5 md:w-full text-white px-6 sm:px-8 pb-8 mx-4 sm:mx-8 text-left font-robout">
              <li className="my-1 flex xl:flex-row flex-col xl:block gap-1">
                <span className="text-[#d78558] font-bold">
                  Get Authorization :{" "}
                </span>{" "}
                <span>
                  The client needs to sign a HIPAA-compliant medical release and
                  draft a valid subpoena.
                </span>
              </li>
              <li className="my-1 flex xl:flex-row flex-col xl:block gap-1">
                <span className="text-[#d78558] font-bold">
                  Set Up Your Account :{" "}
                </span>{" "}
                <span>
                  Create an account with your firm’s details on Clearpath’s
                  Attorney Portal.
                </span>
              </li>
              <li className="my-1 flex xl:flex-row flex-col xl:block gap-1">
                <span className="text-[#d78558] font-bold">
                  Submit Your Request :{" "}
                </span>{" "}
                <span>
                  Enter the patient/client information, attach the subpoena, and
                  specify the records needed.
                </span>
              </li>{" "}
              <li className="my-1 flex xl:flex-row flex-col xl:block gap-1">
                <span className="text-[#d78558] font-bold">
                  Pay Securely :{" "}
                </span>{" "}
                <span>
                  Pay online with a credit card or ACH once an invoice is
                  received through Clearpath. The fee will be according to the
                  record type requested, turnaround, and under state law.
                </span>
              </li>
              <li className="my-1 flex xl:flex-row flex-col xl:block gap-1">
                <span className="text-[#d78558] font-bold">
                  Download Records :{" "}
                </span>{" "}
                <span>
                  Once the billing is processed, records and images can be
                  accessed instantly. Certified affidavits and billing
                  statements included as needed.
                </span>
              </li>
            </ul>
            <h2 className="lg:text-4xl text-3xl text-[#d78558] font-bold md:px-8 px-4 w-full sm:w-4/5 md:w-full pb-8">
              Support At Every Step of the Way
            </h2>
            <p className="xl:text-[1.33rem] text-base sm:text-lg text-white lg:ps-0 md:px-8 w-full sm:w-4/5 md:w-full px-4 pb-8  font-robout">
              Got stuck and need help with Clearpath? Contact our Clearpath
              support team at :
            </p>
            <ul className="xl:text-[1.33rem]  md:text-lg text-lg flex flex-col gap-3 w-full md:ps-20 text-white px-8 pb-8  text-left font-robout">
              <li>
                <span className="text-[#d78558]">Phone : </span>{" "}
                <a href="tel:8887571255"> 888-757-1255</a>
              </li>
              <li>
                <span className="text-[#d78558]">Email : </span>{" "}
                <a href="mailto: support@myclearpath.com">
                  support@myclearpath.com
                </a>
              </li>
            </ul>
            <p className="xl:text-[1.33rem] text-base sm:text-lg text-white lg:ps-0 md:px-8 px-4 pb-8 w-full sm:w-4/5 md:w-full font-robout break-words">
              Our CDC team is always here to support your casework with reliable
              imaging access and responsive service.
            </p>
            <h2 className="lg:text-4xl text-3xl text-[#d78558] font-bold md:px-8 px-4 w-full sm:w-4/5 md:w-full pb-8">
              Why Attorneys Trust Clearpath
            </h2>

            <ul className="xl:text-[1.33rem] list-disc text-base sm:text-lg flex flex-col gap-3 w-full sm:w-4/5 md:w-full text-white px-6 sm:px-8 pb-8 mx-4 sm:mx-8 text-left font-robout">
              <li>Eliminate mail, fax, and disc hassles.</li>
              <li>
                Reliable and quick delivery for deposition and court deadlines.
              </li>
              <li>Secure chain of audit logs for every request.</li>
              <li>Easy sharing with your team, experts, and in courts.</li>
            </ul>
            <h2 className="lg:text-4xl text-3xl text-[#d78558] font-bold md:px-8 px-4 w-full sm:w-4/5 md:w-full pb-8">
              Getting Started
            </h2>
            <p className="xl:text-[1.33rem] text-base sm:text-lg text-white lg:ps-0 md:px-8 w-full sm:w-4/5 md:w-full px-4 pb-8 font-bold font-robout">
              To send us a request for your patient’s radiology report and
              images, please reach out to us directly with the following
              details, and we will process a digital release of your patient's
              images.
            </p>

            <ul className="xl:text-[1.33rem] list-disc text-base sm:text-lg flex flex-col gap-3 w-full sm:w-4/5 md:w-full text-white px-6 sm:px-8 pb-8 mx-4 sm:mx-8 text-left font-robout">
              <li>Submit a request directly to our center.</li>
              <li>Reliable, secure transmission and viewing</li>
              <li>
                Provide the following details:
                <ul className="xl:text-[1.33rem] mt-4 list-disc text-base sm:text-lg flex flex-col gap-3 w-full text-white px-6 sm:px-8 mx-4 sm:mx-8 text-left font-robout">
                  <li>Enter site details</li>
                  <li>Name</li>
                  <li>Email</li>
                  <li>Phone</li>
                  <li>Any additional necessary information</li>
                </ul>
              </li>
            </ul>

            <p className="xl:text-[1.33rem] text-base sm:text-lg text-white lg:ps-0 w-full sm:w-4/5 md:w-full md:px-8 px-4 pb-8 mx-4 text-left font-robout break-words">
              Streamline your record requests at Citrus Diagnostic Center and
              experience the speed and confidence of 100% digitally secured
              record retrieval with Clearpath.
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default Attorney;
